export default __webpack_public_path__ + "static/media/Main.1d52c1c5.png";